import { venomHistory } from 'client/utils/history/venom-history';

/* The function is used to open a link in a new tab. If the browser blocks pop-up windows, the link opens in the same tab.   https://edmunds.slack.com/archives/C02A1PWTJ/p1748538923628729 */
export const openLinkInNewTab = link => {
  const isOpened = window.open(link, '_blank');

  if (!isOpened) {
    venomHistory.push(link);
  }
};
